import { TheiaApi } from '@lved/api-gateway';
import type { IPlatformApi } from '@lved/shared-core';

type WindowWithPlatformApi = Window & {
    _platformApi?: IPlatformApi;
};

const windowWithPlatformApi: WindowWithPlatformApi = window as WindowWithPlatformApi;

if (!windowWithPlatformApi._platformApi) {
    windowWithPlatformApi._platformApi = new TheiaApi();
}
